import { doc, getDoc } from 'firebase/firestore';

import { FSCollections } from '@src/constants/database';
import { db } from '@src/firebase/firebase';
import UserJob from '@src/models/UserJob';
import { getDocData } from '@src/packages/utils';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class UserJobRepository {
  constructor() {
    this.organizationCollection = FSCollections.ORGANIZATIONS;
    this.userJobCollection = FSCollections.USER_JOBS;
    this.userJob = new UserJob();
  }

  getUserJobsPath(orgId) {
    return `${this.organizationCollection}/${orgId}/${this.userJobCollection}`;
  }

  async create(data) {
    return safeExecute(async () => {
      const collectionName = this.getUserJobsPath(data?.organizationId);
      this.userJob.setData(data);
      const res = await createOperation(collectionName, null, this.userJob, 'create');

      return res;
    });
  }

  async update(data) {
    return safeExecute(async () => {
      const collectionName = this.getUserJobsPath(data.organizationId);
      this.userJob.setData(data);
      const userJob = this.userJob.toUpdate();
      const res = await createOperation(collectionName, data.id, userJob, 'update');

      return res;
    });
  }

  async delete({ organizationId, userJobId }) {
    return safeExecute(async () => {
      const collectionName = this.getUserJobsPath(organizationId);
      await createOperation(collectionName, userJobId, null, 'delete');
    });
  }

  async getUserJob({ organizationId, userJobId }) {
    return safeExecute(async () => {
      const userJobRef = doc(db, `${this.getUserJobsPath(organizationId)}/${userJobId}`);
      const docSnap = await getDoc(userJobRef);
      const userJobData = getDocData(docSnap);

      return userJobData;
    });
  }
}

export default UserJobRepository;
